import React, { useState, useEffect } from "react";
import Modal from "../../../components/modal";
import { Download, Minus, Plus } from "lucide-react";
import { API_URL } from "../../../utils/constant";
import axios from "axios";

const RawProductDetailModal = ({ show, onClose, heading, initialData = [], categories = [], suppliers = [] }) => {

    console.log('oind', initialData);
    return (
        <Modal
            show={show}
            onClose={onClose}
            heading={heading}
        >
            {initialData?.RawProductVendors.map((data, index) => {
                const barcodeUrl = `${API_URL}${data.barcode_image}`;
                const handleDownload = async () => {
                    try {
                        const response = await fetch(barcodeUrl);
                        const blob = await response.blob();
                        const blobUrl = URL.createObjectURL(blob);
            
                        const a = document.createElement("a");
                        a.href = blobUrl;
                        a.download = `barcode.png`;
                        document.body.appendChild(a);
                        a.click();
                        document.body.removeChild(a);
                        URL.revokeObjectURL(blobUrl); // Clean up
                    } catch (error) {
                        console.error("Error downloading barcode:", error);
                    }
                };
                return (
                    <div className="row align-item-center justify-center mb-4 pb-3" key={index} style={{
                        borderBottom: "1px solid #eee",
                        alignItems: "center"
                    }}>
                        <div className="col-md-5">
                            <img src={barcodeUrl} alt="barcode" height="120px" />
                        </div>
                        <div className="col-md-5">
                            <strong>Vendor Name</strong>
                            <h5>{data.suppliers?.name}</h5>
                        </div>
                        {/* <div className="col-md-2">
                            <strong>Price</strong>
                            <h5>{data.purchase_cost}</h5>
                        </div>
                        <div className="col-md-2">
                            <strong>Quantity</strong>
                            <h5>{data.quantity}</h5>
                        </div> */}
                        <div className="col-md-2">
                            <button type="button" onClick={handleDownload} className="btn btn-primary btn-sm mt-2">
                                <Download/>
                            </button>
                        </div>
                    </div>
                );
            })}

        </Modal>
    );
};

export default RawProductDetailModal;
